module.exports = __webpack_public_path__ + "static/media/Terms&Conditions.f70522a9.pdf";